import {buildField} from '@eitje/form'
import * as React from 'react'
import * as _ from 'lodash'
import {DatePeriodPicker} from '~/components'
import {formatDatePeriod} from '@eitje/utils'
import {DatePickerFieldTrigger} from '../root'

export const DatePeriodPickerField = React.memo(
	buildField(
		fieldProps => {
			const selectedDate = Array.isArray(fieldProps.value) ? fieldProps.value[0] : fieldProps.value

			return (
				<DatePeriodPicker
					{...fieldProps}
					value={selectedDate}
					renderTrigger={ctx => {
						const hasValue = Boolean(ctx.value)
						let displayValue = fieldProps.placeholder

						if (hasValue && !fieldProps.displayFormatFn) displayValue = formatDatePeriod(ctx.value, fieldProps.periodType)
						if (hasValue && fieldProps.displayFormatFn) displayValue = fieldProps.displayFormatFn(ctx.value)

						return <DatePickerFieldTrigger isPlaceholderShown={!hasValue}>{displayValue}</DatePickerFieldTrigger>
					}}
				/>
			)
		},
		{className: 'date-picker-field', icon: true},
	),
	_.isEqual,
)
